export interface IChangePasswordRequest {
    oldPassword: string;
    newPassword: string;
}
